import { countries } from '@/constants';

const descriptive = {
  name: {
    title: 'Name',
  },
  color: {
    title: 'Color',
  },
  origin: {
    title: 'Origin',
    type: 'dropdown',
    params: {
      title: 'Material Country of Origin',
      values: countries,
    },
  },
  composition: {
    title: 'Composition',
    params: {
      attributes: {
        placeholder: 'e.g. 100% cotton',
      },
    },
  },
  care: {
    title: 'Care details',
    params: {
      attributes: {
        placeholder: 'e.g. Wipe with dry cloth',
      },
    },
  },
  notes: {
    title: 'Notes',
    type: 'textarea',
    params: {
      newline: true,
    },
  },
};

const physical = {
  weight: {
    title: 'Weight',
    prefix: 'gsm',
    params: {
      attributes: {
        type: 'number',
      },
    },
  },
  width: {
    title: 'Width',
    prefix: 'cm',
    params: {
      attributes: {
        type: 'number',
      },
    },
  },
  shrinkage: {
    title: 'Shrinkage',
    prefix: '%',
    params: {
      attributes: {
        type: 'number',
      },
    },
  },
  thickness: {
    title: 'Thickness',
    prefix: 'mm',
    params: {
      attributes: {
        type: 'number',
      },
    },
  },
};

export default {
  descriptive,
  physical,
};
